import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import SectionTitle from '@components/SectionTitle';
import { SelectedExtendedOffer } from '@utils/backend-api/subscribe';

import Tag from '../OfferSelection/Tag';

interface SelectedSubscriptionProps {
  selectedOffer: SelectedExtendedOffer;
}

const SelectedSubscription = ({
  selectedOffer: { title, description, isBestValue },
}: SelectedSubscriptionProps) => {
  return (
    <>
      <SectionTitle title="Your subscription" />
      <div className="mt-32 flex flex-row items-start sm:items-center">
        <h2 className="m-0 font-serif text-[26px] font-bold text-black">{title}</h2>
        {isBestValue && <Tag name="Best Value" className="best-value ml-24" />}
      </div>
      <div className="my-16 font-sans text-paragraph text-black">
        {ReactHtmlParser(description)}
      </div>
    </>
  );
};

export default SelectedSubscription;
